import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useImageLibrary from '@hooks/useImageLibrary'

import type { ImageLibraryModel } from '@models/types'

import placeholderImageUrl from '../../assets/placeholder.svg'

interface ImageLibraryListItemProps {
  imageLibrary: ImageLibraryModel,
}

const ImageLibraryListItem = (props: ImageLibraryListItemProps) => {
  const {
    imageLibrary,
    imageLibrary: { title },
  } = props

  const imageLibraryPayload = useImageLibrary(imageLibrary)
  const {
    callbacks: {
      createOrEditImageLibrary,
    },
    coverImage,
  } = imageLibraryPayload

  // @ts-expect-error TS2339
  const { square_url } = coverImage || {}

  return (
    <Box
      flexDirection="column"
      onClick={() => createOrEditImageLibrary()}
      style={{ cursor: 'pointer' }}
      variant="white"
      overflow="hidden"
    >
      <ListItem
        boxProps={{ borderBottom: '1px dashed', padding: 'large' }}
        showAngleIcon
      >
        <Box flexDirection="column" minWidth="0" paddingRight="medium" width="auto">
          <Text fontSize="small" variant="ellipsis">
            {title}
          </Text>
        </Box>
      </ListItem> 
      <Image
        backgroundSize="cover"
        borderRadius="0 0 5px 5px"
        height={120}
        placeholderUrl={placeholderImageUrl}
        url={square_url}
      />
    </Box>
  )
}

export default ImageLibraryListItem
